import { h } from 'preact';
import { CountdownTimer } from '../CountdownTimer';
import { T } from '../../../styles/tokens';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'CountdownTimer',
  category: '🏷️ Badges & Indicadores',
  description: 'Timer regressivo com Dias/Horas/Min/Seg',
  usedIn: ['ChatHubPage'],
  example: () => (
    <div style={{ background: T.bg, padding: 20, borderRadius: 12 }}>
      <CountdownTimer startsAt="2026-12-31T00:00:00Z" />
    </div>
  ),
};
